import _ from 'lodash'
import env from '@/env.js'

import qs from 'querystring'

let sizeCap = 1024
function parseSize (size, time = 0) {
  if (size < sizeCap) {
    return [size.toFixed(2), time]
  }
  return parseSize(size / sizeCap, ++time)
}
export function formatSize (size = 0) {
  if (typeof size !== 'number') {
    return ''
  }
  let [sizeFixed, time] = parseSize(size)
  switch (time) {
    case 0:
      return `${sizeFixed} B`
    case 1:
      return `${sizeFixed} KB`
    case 2:
      return `${sizeFixed} MB`
    case 3:
      return `${sizeFixed} GB`
    case 4:
      return `${sizeFixed} TB`
    case 5:
      return `${sizeFixed} PB`
    default:
      return '档案巨大，奴婢承受不起'
  }
}
export function formatErrorKey (key) {
  switch (key) {
    case 'phone':
      return '手机格式错误'
    case 'input_password':
      return '密码长度6-16位'
    default:
      return null
  }
}
export function parseError (e, defaultMsg = '未知错误') {
  if (!e) {
    return defaultMsg
  }
  if (typeof e === 'string') {
    return e
  }
  return e.errMsg || e.message || e.code || defaultMsg
}
export function buildUrl (rootDomain, key, entrypoint = '', params = null) {
  let qstr = ''
  if (params) {
    qstr = `?${qs.stringify(params)}`
  }
  switch (key) {
    case 'dcV1':
      return `https://api.dartcome.${rootDomain}/v1.0${entrypoint}${qstr}`
    case 'dcV2':
      return `https://dartcome.${rootDomain}${entrypoint}${qstr}`
    case 'dcV2Graphql':
      return `https://dartcome.${rootDomain}/api/graphql`
    case 'ranch':
      return `https://api.ranch.nutsbp.${rootDomain}${entrypoint}${qstr}`
    case 'nutsbp':
      return `https://api.thomas.nutsbp.${rootDomain}${entrypoint}${qstr}`
    case 'nutsbpConf':
      return `https://static.thomas.nutsbp.com/nutsbp-config${entrypoint}${qstr}`
    case 'editor':
      return `https://bp.nutsbp.${rootDomain}${qstr}`
    case 'editorSignup':
      return `https://bp.nutsbp.${rootDomain}/signUp${qstr}`
    case 'editorForget':
      return `https://bp.nutsbp.${rootDomain}/Forget${qstr}`
    case 'editorPreview':
      return `https://editor.nutsbp.${rootDomain}/preview`
    case 'editorDownload':
      return `https://download.nutsbp.${rootDomain}${qstr}`
    default:
      return ''
  }
}

const regex = {
  weixin: /^([a-zA-Z][\w-]{5,19}|[1-9]\d{4,19})$/
}

export default {
  pathToUserId (path = '') {
    let pre3 = path.substring(0, 3)
    if (pre3 !== '/p/' && pre3 !== '/u/') {
      return null
    }
    let match = path.substring(3).match(/^([a-zA-Z0-9-]+)/)
    return match ? match[0] : match
  },
  isWeixin (weixin) {
    if (!_.isString(weixin)) {
      return false
    }
    return regex.weixin.test(weixin)
  },
  imgCdnSuffix () {
    let suffix = 'basic='
    if (env.isChrome) {
      suffix += '.webp'
    }
    return suffix
  },
  errorToMessage (e) {
    if (e === null) {
      return e
    }
    if (typeof e === 'string') {
      return e
    }
    let key = _.get(e, 'response.data.data.name')
    switch (key) {
      case 'input_password':
        return '密码长度为6-16位'
      default:
        return _.get(e, 'response.data.msg') || _.get(e, 'message')
    }
  }
}



// WEBPACK FOOTER //
// ./src/util.js